import ToneChip from './tone-chip';
import { useIntl } from 'react-intl';
import EmptyTickets from './empty-tickets';
import { TicketSectionProps } from '../types';
import TicketListItem from './ticket-list-item';
import { Box, Paper, Stack, alpha, Skeleton, useTheme, Typography } from '@mui/material';

const TicketSection = ({ icon, title, description, count, tickets, tone, loading }: TicketSectionProps) => {
  const intl = useIntl();
  const theme = useTheme();
  const color = theme.palette[tone].main;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '8px',
        bgcolor: 'background.paper',
      }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} justifyContent="space-between" alignItems="flex-start">
          <Stack direction="row" spacing={1.25} sx={{ minWidth: 0 }}>
            <Box
              sx={{
                width: 38,
                height: 38,
                display: 'grid',
                flexShrink: 0,
                color,
                placeItems: 'center',
                borderRadius: '8px',
                bgcolor: alpha(color, theme.palette.mode === 'dark' ? 0.18 : 0.1),
                '& .MuiSvgIcon-root': { fontSize: 21 },
              }}>
              {icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                {title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Box>
          </Stack>

          <ToneChip
            tone={tone}
            label={intl.formatMessage({ id: 'freshdesk.ticketCount' }, { count: intl.formatNumber(count) })}
          />
        </Stack>

        {loading ? (
          <Stack spacing={1.5}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} variant="rounded" height={132} sx={{ borderRadius: '8px' }} />
            ))}
          </Stack>
        ) : tickets.length ? (
          <Stack spacing={1.5}>
            {tickets.map((ticket) => (
              <TicketListItem key={ticket.id} ticket={ticket} />
            ))}
          </Stack>
        ) : (
          <EmptyTickets />
        )}
      </Stack>
    </Paper>
  );
};

export default TicketSection;
